import { Box, styled } from '@mui/material';
import { Column, Row } from 'components/Layout';

type Props = {
  icon: React.ReactNode;
  primaryLabel: React.ReactNode;
  secondaryLabel: React.ReactNode;
  actions: React.ReactNode;
  secondaryActions: React.ReactNode;
};

const Card = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: theme.spacing(theme.spacingSizes.sm),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
}));

const RightColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,
}));

const ChecklistCard: React.FC<Props> = ({
  icon,
  primaryLabel,
  secondaryLabel,
  actions,
  secondaryActions,
}) => {
  return (
    <Card>
      <Column spacing="lg">
        <Row centered spacing="xs">
          {icon}
          {primaryLabel}
        </Row>
        {secondaryLabel}
      </Column>
      <RightColumn>
        {actions}
        {secondaryActions}
      </RightColumn>
    </Card>
  );
};

export default ChecklistCard;
